// src/lib/blog/utils/icon-map.tsx

import { 
  RiBarChartBoxLine,
  RiLineChartLine,
  RiTestTubeLine,
  RiLightbulbLine,
  RiNewspaperLine,
  RiRobot2Line,
  RiDashboardLine,
  RiGlobalLine,
  RiCodeLine,
  RiMoneyDollarCircleLine,
  RiArticleLine,
  RiPieChartLine,
  RiMegaphoneLine,
  RiVideoLine,
} from "~/icons/remix"

const iconMap = {
  'bar-chart-box': RiBarChartBoxLine,
  'line-chart': RiLineChartLine,
  'test-tube': RiTestTubeLine,
  'lightbulb': RiLightbulbLine,
  'newspaper': RiNewspaperLine,
  'robot-2': RiRobot2Line,
  'dashboard': RiDashboardLine,
  'global': RiGlobalLine,
  'code': RiCodeLine,
  'money-dollar-circle': RiMoneyDollarCircleLine,
  'article': RiArticleLine,
  'pie-chart': RiPieChartLine,
  'megaphone': RiMegaphoneLine,
  'video': RiVideoLine,
}

/** Known icon keys — exported so callers/tests can validate a name resolves to a
 *  real icon rather than silently falling back to `RiArticleLine`. */
export const ICON_NAMES = Object.keys(iconMap) as Array<keyof typeof iconMap>

export function isKnownIconName(iconName: string): iconName is keyof typeof iconMap {
  return Object.prototype.hasOwnProperty.call(iconMap, iconName)
}

export function getIconComponent(iconName: string): typeof RiArticleLine {
  return iconMap[iconName as keyof typeof iconMap] || RiArticleLine
}